module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/info-circle-1f370cedaeec30721603b64e9bf45b05.svg";